export default {
  common: {
    months: {
      short: {
        0: 'Jan',
        1: 'Feb',
        2: 'Mar',
        3: 'Apr',
        4: 'May',
        5: 'Jun',
        6: 'Jul',
        7: 'Aug',
        8: 'Sep',
        9: 'Oct',
        10: 'Nov',
        11: 'Dec',
      },
      long: {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December',
      },
    },
    language: 'English',
    changeLanguage: 'Change language',
    currency: ',-',
    errors: {
      auth: {
        fetchToken: 'Failed to fetch token',
        retrieveToken: 'Failed to retrieve access token',
        missingCredentials:
          'User is not logged in or missing required credentials',
        loginRequired: 'Please log in to continue',
      },
    },
    session: {
      expired: 'Session Expired',
      expiredMessage:
        'Your session has expired. Please reload the page to continue.',
    },
    actions: {
      add: 'Add',
      remove: 'Remove',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      saveSelection: 'save selection',
      cancel: 'Cancel',
      close: 'Close',
      readMore: 'Read more',
      showLess: 'Show less',
      confirm: 'Confirm',
      continue: 'Continue',
      confirmContinue: 'Confirm and Continue',
      back: 'Back',
      or: 'Or',
      reload: 'Reload',
      navigate: {
        nextDay: 'Next day',
        previousDay: 'Previous day',
        home: 'Home',
      },
    },
    status: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      empty: 'No items available',
      noResults: 'No results found',
    },
    passenger: {
      adult: 'Adult',
      child: 'Child',
      infant: 'Infant',
      student: 'Student',
      senior: 'Senior',
      companion: 'Companion',
      conscript: 'Conscript',
      title: 'Passengers',
      singlePassenger: '{count} {type}',
      multiplePassengers: '{count} passengers',
    },
    passengerCount: {
      adult: '{count} Adult | {count} Adults',
      child: '{count} Child 0-5 | {count} Children 0-5',
      youth: '{count} Child 6-17 | {count} Children 6-17',
      student: '{count} Student | {count} Students',
      senior: '{count} Senior | {count} Seniors',
      conscript: '{count} Conscript | {count} Conscripts',
      companion: '{count} Companion | {count} Companions',
    },
  },
  header: {
    home: 'Home',
    myBookings: 'My Bookings',
    support: 'Support',
    search: 'Search Journey',
    myPage: 'My Page',
    logout: 'Log out',
  },
  booking: {
    search: 'Search',
    from: 'From',
    to: 'To',
    date: 'Date',
    passengers: 'Passengers',
    findTickets: 'Find Tickets',
    selectReturn: 'Continue',
    bookingNumber: 'Booking Number',
    outbound: 'Outbound',
    inbound: 'Return',
  },
  search: {
    title: 'Choose your destination',
    originLabel: 'I will travel from stop',
    destinationLabel: 'I will travel to stop',
    originPlaceholder: 'From',
    destinationPlaceholder: 'To',
    departureDate: 'Departure',
    returnDate: 'Return',
    continue: 'Continue',
    noResults: 'No results found',
    loading: 'Loading...',
    switchDirection: 'Switch direction',
    calendar: {
      selectDate: 'Select date',
      today: 'Today',
      tomorrow: 'Tomorrow',
      nextWeek: 'Next week',
      custom: 'Custom date',
    },
  },
  ticketCard: {
    platform: "Platform",
    cancelled: "Cancelled",
    bookingNumber: "Booking number",
    showTicket: "Show ticket"
  },
  afterSale: {
    afterSaleAvalibleMessage:
      'If you wish to modify your return journey after the outbound journey has passed, please get in touch with <a href="https://www.nor-way.no/kontakt-oss/kundeservice/" target="_blank" rel="noopener noreferrer">customer service</a>.',
    cancellation: {
      title: 'Cancellation',
      confirmTitle: 'Confirm Cancellation',
      close: 'Close',
      reviewChoices: 'Review Your Choices',
      directions: {
        outbound: 'Outbound',
        return: 'Return',
      },
      refundAmount: 'Refund Amount',
      currency: 'NOK',
      refundText: 'This amount will be refunded to your payment method',
      cancel: 'Cancel',
      confirm: 'Confirm Cancellation',
      processing: 'Processing...',
    },
    rebook: {
      title: 'Change journey',
      backToTickets: 'Back to my tickets',
      loading: 'Loading...',
      changeOutbound: 'Change outbound journey',
      changeReturn: 'Change return journey',
      changeEntireTrip: 'Change trip',
      continue: 'Continue with selected journey',
      confirm: 'confirm',
      error: 'Something went wrong',
      revertError: 'Could not revert the changes in the booking.',
      modalTitles: {
        outbound: 'Change outbound journey',
        inbound: 'Change return journey',
        entire: 'Change trip',
      },
      search: {
        title: 'Search for new journey',
        continue: 'Continue with selected journey',
        errors: {
          noAvailableJourneys: 'No available journeys found',
          invalidSearch: 'Invalid search',
          networkError: 'Network error',
          general: 'An error occurred',
          noItemsSelected: 'No tickets selected',
          originStationNotSet: 'Departure station not selected',
          destinationStationNotSet: 'Arrival station not selected',
          departureDateNotSet: 'Departure date not selected',
        },
      },
    },
    addons: {
      addSeat: 'Add seat',
      selectAddons: 'Select add-ons',
    },
    actions: {
      rebook: 'Change Journey',
      cancel: 'Cancel Journey',
      changeOwner: 'Change Journey Owner',
      viewReceipt: 'View Receipt',
    },
  },
  payment: {
    title: 'Payment',
    contactInformation: 'Contact Information',
    buyingForOthers: 'I am buying the ticket for someone else',
    passengerContactInfo: 'Passenger Contact Information',
    confirm: 'Confirm',
    passengerHelpText:
      'Help text explaining what happens when you fill out information here - for the person getting the ticket by email etc.',
    methods: {
      card: 'Card',
      title: 'Payment Methods',
      payNow: 'Go to payment',
      processRefund: 'Process refund',
      specification: 'Payment specification',
      total: 'Total',
      proceed: 'Proceed to payment',
      processing: 'Processing payment...',
      confirm: 'Confirm payment',
    },
    voucher: {
      title: 'Voucher',
      code: 'Voucher code',
      add: 'Add voucher',
      remove: 'Remove voucher',
    },
    refundInfo: {
      title: 'Refund Information',
      amount: 'Refund amount: {amount} NOK',
      confirm: 'Request Refund',
    },
    error: {
      invalidCard: 'Invalid card details',
      noBooking: 'no active booking found',
      paymentFailed: 'Payment failed',
      vippsFailed: 'Vipps paymend Failed',
      cancelled: 'Payment cancelled',
    },
  },
  components: {
    backLink: 'Back',
    error: {
      title: 'Error',
      retry: 'Retry',
      close: 'Close',
    },
    form: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      postalCode: 'Postal code',
      city: 'City',
      required: 'Required field',
      invalid: 'Invalid value',
    },
    button: {
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      confirm: 'Confirm',
      continue: 'Continue',
      back: 'Back',
    },
    drawer: {
      close: 'Close',
    },
    breadcrumbs: {
      home: 'Home',
    },
    dropdown: {
      select: 'Select',
      noResults: 'No results found',
    },
    userInfo: {
      details: 'Details',
      editProfile: 'Edit Profile',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      password: 'Password',
      save: 'Save',
      cancel: 'Cancel',
      changePassword: 'Change Password',
      updatePassword: 'Update Password',
      logout: 'Log Out',
      deleteAccount: 'Delete Account',
      deleteAccountConfirmation:
        'Are you sure you want to delete your account?',
      deleteAccountWarning: 'This action cannot be undone.',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      confirmAccount: {
        title: 'Set your password',
        description:
          'Please set your password to complete your account creation.',
        password: 'New password',
        passwordPlaceholder: 'Enter your new password',
        confirmPassword: 'Confirm password',
        confirmPasswordPlaceholder: 'Confirm your new password',
        confirm: 'Set password',
        submit: 'Set password',
        success: 'Password set successfully! Redirecting...',
        passwordRequirements:
          'Password must be at least 10 characters and contain at least one uppercase letter, one digit, and one symbol.',
        passwordsDoNotMatch: 'Passwords do not match',
        invalidConfirmationLink: 'Invalid confirmation link',
        errorMessage: 'Could not confirm account',
      },
    },
  },
  travelPlanner: {
    booking: {
      errors: {
        unexpected: 'Something went wrong please try again',
      },
    },
    search: {
      origin: 'From',
      destination: 'To',
      switchDirection: 'Switch direction',
      date: {
        departure: 'Departure',
        return: 'Return',
      },
    },
    hero: {
      planningLabel: 'Plan your journey',
      searchResultLabel: 'Available journeys',
      passengers: 'travellers',
      changeSearch: 'Change search',
      roundtrip: 'Round trip',
      oneWay: 'One way',
      passengerLabel: 'Choose passengers',
      searchReturn: 'Choose return journey',
      searchOutbound: 'Choose outbound journey and ticket',
      changeOutbound: 'Change outbound journey',
      changeReturn: 'Change return journey',
    },
    myTravel: {
      title: 'My Travel',
      outbound: 'outbound',
      inbound: 'return',
      notSelected: {
        outbound: 'outbound not selected',
        inbound: 'return not selected',
      },
      list: {
        seats: 'seats',
        currency: 'NOK',
        rebookingFee: 'Rebooking fee',
        total: 'Total to pay',
        equipment: {
          count: '{count} {type} - {code}',
        },
      },
    },
    passenger: {
      title: 'Choose passengers',
      removePassenger: 'Remove',
      addPassenger: 'Add',
      description: 'Passengers',
      travelCard: {
        placeholder: 'Select travel card',
        addTravelCard: 'Add travel card',
      },
    },
    equipmentPage: {
      equipmentHeader: 'Book products for your journey',
      equipmentLabel: 'Select add-ons',
      noProducts:
        'There are no available additional products on this part of your journey',
    },
    guestUser: {
      continueAsGuest: 'Continue as guest',
      noProfile: 'No profile?',
      guestWarning:
        'Without a profile, you will not have a complete overview of your tickets and receipts.',
    },
    journeyList: {
      details: {
        title: 'Journey Details',
        stops: 'stops',
        transfer: 'transfer',
        transfers: 'transfers',
        waitingTime: 'Transfer, {time} min',
        platform: 'Platform',
        track: 'Track',
      },
      travel: {
        from: 'From',
        to: 'To',
        departure: 'Departure',
        arrival: 'Arrival',
        duration: 'Duration',
        price: 'From',
        seats: 'Available seats',
        transfer: 'Transfer',
        direct: 'Direct',
        full: 'Sold out',
        few: 'Few seats left',
        platform: 'Platform',
        track: 'Track',
        'Not open for sale': 'Not open for sale',
      },
      tickets: {
        title: 'Select Ticket',
        standard: 'Standard',
        flex: 'Flex',
        description: 'Description',
        conditions: 'Conditions',
        select: 'Select',
        selected: 'Selected',
      },
    },
    seat: {
      title: 'Select Seat',
      description:
        'Choose your preferred seat or continue and be assigned a seat.',
      rebookDescription:
        'When modifying your ticket, you must re-select your preferred seat. You may also continue and be assigned a seat.',
      skipSelection: 'Proceed without seat selection',
      showDetails: 'Show details',
      seat: 'Seat',
      skipSeats: 'Continue without seats',
      noSeatsSelected: 'No seats selected',
      selectSeats: 'Select seats',
      selectedSeatsOutbound: 'selected seats outbound:',
      selectedSeatsInbound: 'selected seats inbound:',
      seatDescription: 'Seat description',
      partialSeatModal: {
        title: 'Seat selection',
        description:
          'You have only selected seats for one direction. Would you like to select seats for the other direction as well?',
      },
      firstFloor: 'First floor',
      secondFloor: 'Second floor',
      confirmationModal: {
        title: 'Confirm Partial Seat Selection',
        message:
          'You have only selected seats for one direction. Do you want to continue without selecting seats for the other direction?',
      },
      transfer: {
        title: 'Seat Selection',
        description: 'Select seats for each leg of your journey.',
        direction: '%{direction} Journey',
        segement: 'Segment',
      },
      select: 'Select Seats',
      selectedSeat: 'Selected seat',
      change: 'Change Seats',
      loading: 'Loading...',
      noSeatReservation: 'Seat reservation not available for this leg',
      notAvailable: 'Seat selection is not available',
      seatTypes: {
        vacantSeat: 'Vacant',
        unavailableSeat: 'Unavailable',
        comfortSeat: 'Comfort seat',
        panoramaSeat: 'Panorama seat',
        windowSeat: 'Window seat',
        aisleSeat: 'Aisle seat',
        frontSeat: 'Front seat',
        childSeat: 'Child seat',
        standardSeat: 'Standard seat',
      },
      properties: {
        STANDARD_SEAT: 'Standard seat',
        COMFORT_SEAT: 'Comfort seat',
        WINDOW: 'Window seat',
        AISLE: 'Aisle seat',
        TABLE: 'Table seat',
        POWER_OUTLET: 'Power outlet',
        EXTRA_LEGROOM: 'Extra legroom',
        WHEELCHAIR: 'Wheelchair accessible',
      },
    },
  },
  searchResult: {
    navigation: {
      back: 'Back',
      continue: 'Continue',
      changeSearch: 'Change search',
      showDetails: 'Show details',
      drawerTitel: 'Travel details',
    },
    noResults:
      'No journeys are available on the chosen date. Check another day, or edit your search.',
    noResultReturn:
      'Your search did not return a travel option on the chosen day. Try again with other stops or on another date. ',
    journey: {
      outbound: 'Outbound',
      return: 'Return',
      noTravels: 'No journeys available',
      from: 'From',
      to: 'To',
      departure: 'Departure',
      arrival: 'Arrival',
      duration: 'Duration',
      price: 'From',
      seats: 'Available seats',
      transfer: 'Transfer',
      direct: 'Direct',
      full: 'Fully booked',
      few: 'Few seats left',
    },
  },
  myPage: {
    title: 'My Page',
    navigation: {
      bookings: 'My Bookings',
      profile: 'Profile',
      settings: 'Settings',
    },
    auth: {
      title: 'Log in to My page',
      signupTitle: 'Create Account',
      login: 'Log in',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      submit: 'Create account',
      register: 'Register',
      createAccount: 'Create Account',
      haveAccount: 'Do you already have an account?',
      errorGeneral: 'Incorrect username or password',
      invalidCredentials: 'Invalid credentials',
      signup: {
        success: 'Account created',
        error: 'Account creation failed',
        invalidEmail: 'Invalid email address',
        userNotFound: 'User not found',
        sucessMessage: 'Check your email to activate your account',
      },
      passwordRequirements: {
        text: 'Your password must contain at least:',
        rule1: '8 characters',
        rule2: '1 uppercase letter, 1 lowercase letter',
        rule3: '1 number',
        rule4: '1 special character',
      },
      resetPassword: {
        subTitle: 'Reset password',
        title: 'Request new password',
        submit: 'Change password',
        success: 'Password changed',
        placeholder: 'Enter your email',
        error: 'Error changing password',
        errorMessage: 'Error changing password',
        successMessage:
          'If your email address is registered in our systems, you will receive an email with a link to reset password.',
        invalidEmail: 'Invalid email address',
        userNotFound: 'User not found',
      },
      confirmAccount: {
        title: 'Set your password',
        description:
          'Please set your password to complete your account creation.',
        password: 'New password',
        passwordPlaceholder: 'Enter your new password',
        confirmPassword: 'Confirm password',
        confirmPasswordPlaceholder: 'Confirm your new password',
        confirm: 'Set password',
        submit: 'Set password',
        success: 'Password set successfully! Redirecting...',
        passwordRequirements:
          'Password must be at least 10 characters and contain at least one uppercase letter, one digit, and one symbol.',
        passwordsDoNotMatch: 'Passwords do not match',
        invalidConfirmationLink: 'Invalid confirmation link',
        errorMessage: 'Failed to confirm account',
      },
    },
    profile: {
      title: 'My Profile',
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      changePassword: 'Change Password',
      save: 'Save Changes',
      saved: 'Changes saved successfully',
      error: 'Failed to save changes',
    },
    bookings: {
      title: 'My Journeys',
      future: 'Future Journeys',
      past: 'Past Journeys',
      loading: 'Loading journeys...',
      loadingMore: 'Loading more journeys...',
      noFutureBookings: 'You have no future journeys',
      noPastBookings: 'You have no past journeys',
      loadMore: 'Load more journeys',
      error: 'Could not load journeys. Please try again later.',
    },
    ticket: {
      yourTicet: 'Your ticket',
      name: 'Name',
      bookingNumber: 'Booking number',
      passengers: 'Passengers',
      ticketTyp: 'Ticket type',
      seat: 'Seat',
      equipment: 'Equipment',
      discount: 'Discount',
      totalPrice: 'Value',
      actions: 'Actions',
      rebook: 'Rebook',
      cancel: 'Cancel',
      displayQr: 'Display QR code',
      bookingNotFound:
        'We could not load your booking. Please follow link in email to view ticket or use the email receipt as travel document.',
    },
    aftersale: {
      rebook: {
        title: 'Change journey',
      },
    },
    anonymousTicket: {
      title: 'View My Ticket',
      email: 'Email',
      emailPlaceholder: 'Enter your email address',
      bookingNumber: 'Booking Number',
      bookingNumberPlaceholder: 'Enter booking number',
      continue: 'Get My Ticket',
    },
  },
  confirmation: {
    title: 'Booking Confirmation',
    backToTickets: 'To my tickets',
    thankYou: 'Thank you for your order!',
    bookingNumber: 'Booking number',
    receiptEmail: 'Receipt will be sent to your email address',
    downloadTicket: 'Download ticket',
    viewBooking: 'View booking',
  },
  guestUser: {
    continueAsGuest: 'Proceed to payment',
    noProfile: 'Continue as a guest',
    guestWarning:
      'Without My page access, you will not have an overview of your tickets.',
  },
  descriptions: {
    tickets: {
      FLEX: {
        refundable: {
          text: 'Refundable up to 15 min before departure.',
          value: 'true',
        },
        changeable: {
          text: 'Can be changed without change fee up to 15 min before departure. Additional ticket cost may apply.',
          value: 'true',
        },
      },
      STANDARD: {
        refundable: {
          text: 'Non-refundable',
          value: 'false',
        },
        changeable: {
          text: 'Can be changed up to 1 hour before departure. Change fee 39 NOK, additional ticket cost may apply.',
          value: 'true',
        },
      },
    },
    passengerTypes: {
      ADT: 'From 18 years',
      CHD: '0-5 years',
      YOU: '6-18 years',
      STU: 'Student, 18 - 30 years with valid student ID.',
      SEN: 'From 67 years and persons with disability certificate from NAV.',
      CON: 'In compulsory military service with valid ID-card from the Defence ministry.',
      COM: 'Person who accompanies a holder of carer certificate issued by the local municipality.',
    },
    equipmentTypes: {
      LUGGAGE: {
        displayName: 'Extra luggage',
        description:
          'Book extra luggage beyond the 2 pieces included in the ticket price.',
      },
      SPECIAL_LUGGAGE: {
        displayName: 'Special luggage',
        description:
          'Book space for pulk, surfboard, golf bag or other luggage outside normal dimensions.',
      },
      BIKE: {
        displayName: 'Bicycle',
        description: 'Book space for bicycle.',
      },
      SCOOTER: {
        displayName: 'Snow scooter',
        description:
          'Snow scooter transportation between the snow coach end stop and your private cabin.',
      },
      PET: {
        displayName: 'Pet',
        description: 'Book space for pet.',
      },
    },
  },
  rebooking: {
    pastTravel: 'Travel before change',
    newTravel: 'Your new travel',
    seats: 'Seats',
    extraBaggage: 'Extra baggage',
    totalPaid: 'Total amount paid',
    totalToPay: 'Total to pay',
    unavailableProduct: {
      heading: 'Some requested equipment is not available',
      message:
        'Some equipment from your original booking is not available on this journey. You can continue with the rebooking, but you may loose your equipment.',
    },
  },
  seat: {
    window: 'Window seat',
    aisle: 'Aisle seat',
    front: 'Front seat',
  },
}
